import React, { useEffect, useCallback, useRef } from 'react';
import { isWithinInterval } from 'date-fns';
import { SeekType } from '@24i/player-base';
import { useAdsData } from '@24i/player-utils-react';
import { Loader } from '../Loader';
import { PlayerUIContainer } from '../PlayerUIContainer';
import { RegularUI } from './RegularView';
import { AdvertisementUI } from './AdvertisementView';
import { getPlayerUIContainerStyles } from './styled';
export const PlayerUI = ({ playerInstance, useDurationOverRemaining, shouldShowProgressTime = false, shouldShowFooterPlayerButtons = true, shouldShowAirtime = false, shouldShowBufferedRanges = true, styles, onBack, onGoToNextEpisode, asset, seriesData, epgData, relatedItems, blockingReason, blockingMessage, dvrWindowOverride, onUnlockAction, onPlayPausePress, onCurrentProgramChange, }) => {
    const visibilityInfoRef = useRef({
        wasInBackground: document.hidden,
        wasPausedInBackground: playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.paused,
        lastTimePoint: playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.currentTime,
    });
    const onVisibilityChange = useCallback(() => {
        const visibilityInfo = visibilityInfoRef.current;
        const isInBackground = document.hidden;
        if (!visibilityInfo.wasInBackground && isInBackground) {
            visibilityInfo.wasInBackground = true;
            visibilityInfo.wasPausedInBackground = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.paused;
            visibilityInfo.lastTimePoint = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.currentTime;
        }
        else if (visibilityInfo.wasInBackground && !isInBackground) {
            visibilityInfo.wasInBackground = false;
            visibilityInfo.wasPausedInBackground = false;
            if (!isWithinInterval(visibilityInfo.lastTimePoint, playerInstance.timeshiftRange)) {
                playerInstance.seek(0, SeekType.TIMESHIFT);
            }
        }
    }, [playerInstance]);
    const onPause = useCallback(() => {
        if (document.hidden) {
            visibilityInfoRef.current.wasPausedInBackground = true;
        }
    }, []);
    const onTimeUpdate = useCallback(() => {
        const visibilityInfo = visibilityInfoRef.current;
        if (visibilityInfo.wasInBackground && !visibilityInfo.wasPausedInBackground) {
            visibilityInfo.lastTimePoint = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.currentTime;
        }
    }, [playerInstance]);
    useEffect(() => {
        if (asset.isLive) {
            const visibilityInfo = visibilityInfoRef.current;
            visibilityInfo.wasInBackground = document.hidden;
            visibilityInfo.wasPausedInBackground = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.paused;
            if (visibilityInfo.wasInBackground && !visibilityInfo.wasPausedInBackground) {
                visibilityInfo.lastTimePoint = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.currentTime;
            }
            document.addEventListener('visibilitychange', onVisibilityChange);
            playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.addEventListener('pause', onPause);
            playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.addEventListener('timeupdate', onTimeUpdate);
        }
        return () => {
            document.removeEventListener('visibilitychange', onVisibilityChange);
            playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.removeEventListener('pause', onPause);
            playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.removeEventListener('timeupdate', onTimeUpdate);
        };
    }, [playerInstance]);
    const { isPlayingClientAd } = useAdsData(playerInstance);
    return (React.createElement(PlayerUIContainer, { playerInstance, blockingReason, style: getPlayerUIContainerStyles(blockingReason) },
        !isPlayingClientAd ? (React.createElement(RegularUI, { playerInstance,
            useDurationOverRemaining,
            shouldShowProgressTime,
            shouldShowFooterPlayerButtons,
            shouldShowAirtime,
            shouldShowBufferedRanges,
            onBack,
            onGoToNextEpisode,
            asset,
            seriesData,
            epgData,
            blockingReason,
            blockingMessage,
            relatedItems,
            dvrWindowOverride,
            onUnlockAction,
            onPlayPausePress,
            onCurrentProgramChange,
            styles })) : (React.createElement(AdvertisementUI, { playerInstance })),
        React.createElement(Loader, { playerInstance: playerInstance })));
};
export * from './components';
//# sourceMappingURL=index.js.map